import React, { useEffect, useState, useCallback } from "react";
import { get_myHistory } from "@/api/aicopy";
import { getProfitColorClass } from "../../utils/colorScheme";
import arrowRight from "assets/images/aicopy/898172df-f017-4eff-be9d-a2b6fe27e1fa.svg";
import tagBackground from "assets/images/aicopy/7e4271f1-feec-44a0-9dcc-aeec6f8ed213.svg";
import tagIcon from "assets/images/aicopy/ae0a5b7b-f195-4586-9300-03ed4ed14813.svg";
import { mapAicopyHistoryOrderItem } from "../../utils/mapAicopyHistoryOrderItem";
import OrderCardCornerBadge from "../OrderCardCornerBadge";
import styles from "../../index.module.less";

export default function OrderHistoryTab({ active, t, onCardClick }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadHistory = useCallback(async () => {
    setLoading(true);
    try {
      const response = await get_myHistory(50, 0, { isResFull: true });
      if (response.rc === 0 && Array.isArray(response.result)) {
        setList(response.result.map((item) => mapAicopyHistoryOrderItem(item, t)));
      } else {
        setList([]);
      }
    } catch (e) {
      console.error("[aicopy] order history load failed", e);
      setList([]);
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    if (!active) return;
    loadHistory();
  }, [active, loadHistory]);

  if (!active) return null;

  return (
    <div className={styles.ordersList}>
      {loading ? (
        <div className={styles.tabEmptyHint}>{t("aicopy.loading")}</div>
      ) : list.length === 0 ? (
        <div className={styles.tabEmptyHint}>{t("aicopy.noData")}</div>
      ) : (
        list.map((order) => (
          <div
            key={order.id}
            className={`${styles.orderCard} ${styles.orderCardHistory}`}
            onClick={() => onCardClick?.(order.strategyId, "order")}
          >
            <OrderCardCornerBadge isCouponPosition={order.isCouponPosition} t={t} />

            <div className={styles.orderHeader}>
              <div className={styles.orderInfo}>
                <div className={styles.orderIconWrapper}>
                  <img src={order.avatarUrl} alt={order.strategyName} className={styles.orderIcon} />
                </div>
                <div className={styles.orderNameWrapper}>
                  <div className={styles.orderNameGroup}>
                    <span className={styles.orderName}>{order.strategyName}</span>
                    <div className={styles.arrowIcon}>
                      <img src={arrowRight} alt="" />
                    </div>
                  </div>
                </div>
                {/* {order.tag ? (
                  <div className={styles.orderTag}>
                    <div className={styles.tagItem}>
                      {order.tagType === "tactics" ? (
                        <>
                          <div className={styles.tagBg}>
                            <img src={tagBackground} alt="" className={styles.tagBgImg} />
                          </div>
                          <div className={styles.tagIcon}>
                            <img src={tagIcon} alt="" />
                          </div>
                        </>
                      ) : null}
                      <span className={styles.tagText}>{order.tag}</span>
                    </div>
                  </div>
                ) : null} */}
              </div>
            </div>

            <div className={styles.orderStats}>
              <div className={styles.orderStatRow}>
                <div className={styles.orderStatItem}>
                  <div className={styles.orderStatLabel}>{t("aicopy.realizedProfit")}</div>
                  <div
                    className={`${styles.orderStatValue} ${getProfitColorClass(order.profit, styles)}`}
                  >
                    {order.profit}
                  </div>
                </div>
                <div className={`${styles.orderStatItem} ${styles.orderStatItemEnd}`}>
                  <div className={styles.orderStatLabel}>{t("aicopy.totalInvestment")}</div>
                  <div className={styles.orderStatValue}>{order.totalInvestAmount}</div>
                </div>
              </div>
              <div className={styles.orderStatRow}>
                <div className={styles.orderStatItem}>
                  <div className={styles.orderStatLabel}>{t("aicopy.returnRate")}</div>
                  <div className={`${styles.orderStatValue} ${getProfitColorClass(order.totalReturnRate, styles)}`}>
                    {order.totalReturnRate}
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.orderDetails}>
              <div className={styles.orderDetailItem}>
                <span className={styles.orderDetailLabel}>{t("aicopy.followStartTime")}</span>
                <span className={styles.orderDetailValue}>{order.startTime || "—"}</span>
              </div>
              {order.followDays ? (
                <div className={styles.orderDetailItem}>
                  <span className={styles.orderDetailLabel}>{t("aicopy.followDays")}</span>
                  <span className={styles.orderDetailValue}>{order.followDays}</span>
                </div>
              ) : null}
              {order.endTime ? (
                <div className={styles.orderDetailItem}>
                  <span className={styles.orderDetailLabel}>{t("aicopy.followEndTime")}</span>
                  <span className={styles.orderDetailValue}>{order.endTime}</span>
                </div>
              ) : null}
              {order.isCouponPosition && order.couponExpireMs != null ? (
                <div className={styles.orderDetailItem}>
                  <span className={styles.orderDetailLabel}>{t("aicopy.voucherExpireTime")}</span>
                  <span className={styles.orderDetailValue}>{order.voucherExpireTime || "—"}</span>
                </div>
              ) : null}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
